import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/inventorys/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/inventorys/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Inventorys/Save',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Inventorys/Save',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/inventorys/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/inventorys/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/inventorys/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
